<div class="flex flex-col flex-1 overflow-hidden">
  <div class="flex-1 min-h-0 overflow-auto">
    <p-table [value]="rows()" [loading]="isLoading()" dataKey="id" class="p-datatable-sm">
      <ng-template #header>
        <tr>
          <th class="min-w-64 tracking-wide" pSortableColumn="fullName">Name <p-sortIcon field="fullName" /></th>
          <th class="min-w-64 tracking-wide">Email</th>
          <th class="w-32 text-center"></th>
        </tr>
      </ng-template>

      <ng-template #body let-row>
        <tr>
          <td class="text-sm font-medium text-slate-900">{{ row.fullName }}</td>
          <td class="text-sm">{{ row.email }}</td>
          <td class="text-center">
            @if (row.isAssigned) {
              <p-button
                label="Unassign"
                icon="pi pi-user-minus"
                size="small"
                severity="danger"
                [outlined]="true"
                (onClick)="unassign()"
              />
            } @else {
              <p-button label="Assign" icon="pi pi-user-plus" size="small" (onClick)="assign(row)" />
            }
          </td>
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td colspan="3" class="py-8 text-sm text-center">No decor consultants found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
